import { render, staticRenderFns } from "./LotteryActivityPrizes.vue?vue&type=template&id=23dc56e8&scoped=true&"
import script from "./LotteryActivityPrizes.vue?vue&type=script&lang=js&"
export * from "./LotteryActivityPrizes.vue?vue&type=script&lang=js&"
import style0 from "./LotteryActivityPrizes.vue?vue&type=style&index=0&id=23dc56e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dc56e8",
  null
  
)

export default component.exports